/**
 * Анимации поля, конца которых ждет проигрыватель записи матча: удары ближнего
 * боя и залпы выстрелов (см. HexGridRenderer.showMeleeAnimation и
 * showShotAnimation).
 *
 * Такая анимация идет дольше шага воспроизведения, а следующим действием
 * записи может оказаться завершение этапа: погибшие отряды снимаются с поля,
 * и анимация оборвалась бы на полпути. Поэтому, пока она на поле, проигрыватель
 * следующее действие не исполняет (см. ReplayRunner).
 *
 * Знает об анимациях рендерер поля (Phaser), а нужно это проигрывателю (React):
 * отдельный маленький источник, а не redux — это состояние анимации, а не
 * партии. Подписки нет: проигрыватель опрашивает сам, в своем тике.
 */
const deadlineByAnimation = new Map();
// Когда на поле последний раз появился итог такой анимации (Date.now)
let lastResultShownAt = null;

/**
 * Анимация появилась на поле.
 *
 * @param {string} animationKey — ключ, уникальный среди анимаций всех видов
 * @param {number} deadlineAt — к какому моменту (Date.now) она точно должна
 *   отыграть. Кадры в скрытой вкладке не идут, и анимация может зависнуть:
 *   дольше этого срока ее не ждут
 */
export const markAwaitedAnimationPlaying = (animationKey, deadlineAt) => {
  if (!animationKey) {
    return;
  }
  deadlineByAnimation.set(animationKey, deadlineAt);
};

/** Анимация ушла с поля: отыграла целиком или оборвана */
export const markAwaitedAnimationFinished = (animationKey) => {
  deadlineByAnimation.delete(animationKey);
};

/**
 * Итог анимации появился на поле: урон на плашках после ударов, попадание
 * залпа. Сама анимация может уйти с поля почти сразу за ним (удар без потерь,
 * залп стрел) — проигрыватель дает итогу побыть на виду
 */
export const markAwaitedAnimationResultShown = () => {
  lastResultShownAt = Date.now();
};

/**
 * До какого момента (Date.now) ждать анимации, которые сейчас на поле: самый
 * поздний из их сроков
 *
 * @returns {number|null} null — анимаций на поле нет, ждать нечего
 */
export const getAwaitedAnimationsDeadline = () => (
  deadlineByAnimation.size > 0 ? Math.max(...deadlineByAnimation.values()) : null
);

/** @returns {number|null} когда последний раз появился итог; null — еще не появлялся */
export const getLastAwaitedAnimationResultShownAt = () => lastResultShownAt;

/** Забыть все (тесты) */
export const resetAwaitedAnimations = () => {
  deadlineByAnimation.clear();
  lastResultShownAt = null;
};
